"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./view"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@uirouter/core/lib/view/index.js
// module id = 370
// module chunks = 0